module.exports = __webpack_public_path__ + "img/map-key1.06f8c5ad.png";